// extracted by mini-css-extract-plugin
export var numpadContainer = "_ki-1";
export var phoneButton = "_ki-0";